import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function ExpireDialog({
  open,
  onClose,
  onExpire,
}: {
  open: boolean;
  onClose: () => void;
  onExpire: () => void;
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle color="error">クーポン失効の確認</DialogTitle>
      <DialogContent>
        <DialogContentText>
          クーポンを失効してよろしいですか？
          クーポンを失効すると、ユーザーはこのクーポンを使用することはできなくなります。
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default" autoFocus>
          キャンセル
        </Button>
        <Button onClick={onExpire} color="default">
          失効する
        </Button>
      </DialogActions>
    </Dialog>
  );
}
